<template>
  <div class="page">
    <van-nav-bar title="实习项目" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="empty" v-if="showEmpty">
      <img src="../../../../assets/images/sx_empty.png" alt="" />
      <div>暂无实习项目，是否立即添加？</div>
      <div class="button" @click="addProject">
        新增项目
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else style="padding-bottom: 100px">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <div class="item-box" v-for="(item, index) in list" :key="index" @click="handleClick(item)">
          <div class="title-line">
            <div class="title">{{ item.xmmc }}</div>
            <div class="status" :style="{ borderColor: getStatusColor(item.iswfmes), color: getStatusColor(item.iswfmes) }">{{ getStatusText(item.iswfmes) }}</div>
          </div>
          <div class="date">项目时间: {{ item.xmkssj }} ~ {{ item.xmjssj }}</div>
          <div class="tip-box">
            <div class="title">审批意见：</div>
            <div>{{ item.shyj }}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="button-box" v-if="!showEmpty">
      <div class="button" @click="addProject">新增项目</div>
    </div>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      page: 1,
      pageSize: 3,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      showEmpty: false,
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      isty: 'getIsty',
    }),
  },
  methods: {
    async getList() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const res = await iApi.getSxxmList({
        page: this.page,
        size: this.pageSize,
        sxfs: this.isty,
        sxjhid: this.sxjhid,
      })
      this.list = this.list.concat(res.data)
      this.list.splice(0,0)
      this.loading = false
      if (res.data.length < this.pageSize) {
        this.finished = true
      } else {
        this.page += 1
      }
      if(this,this.list.length == 0){
        this.showEmpty = true
      }
    },
    getStatusColor(value) {
      switch (value) {
        case '0':
          return '#F85352'
          break
        case '1':
          return '#41B29C'
          break
        case '2':
          return '#FE923F'
          break
      }
    },
    getStatusText(value) {
      switch (value) {
        case '0':
          return '未通过'
          break
        case '1':
          return '通过'
          break
        case '2':
          return '审核中'
          break
      }
    },
    handleClick(item) {
      this.$router.push({
        path: '/internship/applyStatus',
        query: {
          sxxmid: item.sxxmid,
          config: 2,
        },
      })
    },
    addProject() {
      const iswfmes = this.list.some(item => {
        return item.iswfmes === '5'
      })
      this.$router.push({
        path: '/internship/addJobs',
        query: {
          iswfmes: iswfmes ? '5' : '',
        },
      })
    },
    onRefresh() {
      this.list = []
      this.page = 1
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.getList()
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .tip-box {
    width: 295px;
    height: 43px;
    background: #f2f2f4;
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    padding: 10px;
    .title {
      color: #666666;
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/jobs.vue